import { render } from "./extras.vue?vue&type=template&id=138e440b&scoped=true"
import script from "./extras.vue?vue&type=script&lang=js"
export * from "./extras.vue?vue&type=script&lang=js"

import "./extras.vue?vue&type=style&index=0&id=138e440b&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138e440b"]])

export default __exports__